var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ClickMenu,{staticClass:"event-module-filter",attrs:{"iconPack":"bys-icon","icon":"wave","ids":_setup.modules,"names":_setup.modules,"title":_vm.$t('report.event_modules'),"type":"multiple","position":_vm.position,"value":_vm.value},on:{"input":function($event){return _setup.emitValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }